import { key } from 'piqure';

export const SITE_URL = key<string | undefined>('site-url');
